import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SchoolCO } from '../models/ApiModels';

export interface SchoolState {
  data: SchoolCO | null;
  loading: boolean;
  error: string | null;
}

@Injectable({ providedIn: 'root' })
export class SchoolDetailsService {

  private readonly initialState: SchoolState = {
    data: null,
    loading: false,
    error: null
  };

  private schoolStateSubject =
    new BehaviorSubject<SchoolState>(this.initialState);

  schoolState$ = this.schoolStateSubject.asObservable();

  // -------------------- Actions --------------------

  setLoading(): void {
    const state = this.schoolStateSubject.value;
    if (state.loading) return;

    this.schoolStateSubject.next({
      ...state,
      loading: true,
      error: null
    });
  }

  setSchool(school: SchoolCO): void {
    this.schoolStateSubject.next({
      data: school,
      loading: false,
      error: null
    });

    sessionStorage.setItem('school', JSON.stringify(school));
  }

  setError(message: string): void {
    this.schoolStateSubject.next({
      ...this.schoolStateSubject.value,
      loading: false,
      error: message
    });
  }

  // -------------------- Persistence --------------------

  loadFromSession(): void {
    const raw = sessionStorage.getItem('school');
    if (!raw) return;

    try {
      const school = JSON.parse(raw) as SchoolCO;
      this.setSchool(school);
    } catch {
      sessionStorage.removeItem('school');
      this.setError('Corrupted school data');
    }
  }
}
